console.log("DOM is ready");
$(document).ready(function() {
  // Tab Categories
        $('#parentHorizontalTab').easyResponsiveTabs({
            type: 'default', //Types: default, vertical, accordion
            width: 'auto', //auto or any width like 600px
            fit: true, // 100% fit in a container
            tabidentify: 'hor_1', // The tab groups identifier
            activate: function(event) { // Callback function if tab is switched
                var $tab = $(this);
                var $info = $('#nested-tabInfo');
                var $name = $('span', $info);
                $name.text($tab.text());
                $info.show();
            }
        });

        // Child Tab
        $('#ChildVerticalTab_1').easyResponsiveTabs({
            type: 'vertical',
            width: 'auto',
            fit: true,
            tabidentify: 'ver_1', // The tab groups identifier
            activetab_bg: '#fff', // background color for active tabs in this group
            inactive_bg: '#F5F5F5', // background color for inactive tabs in this group
            active_border_color: '#c1c1c1', // border color for active tabs heads in this group
            active_content_border_color: '#5AB1D0' // border color for active tabs contect in this group so that it matches the tab head border
        });

        //Vertical Tab
        $('#parentVerticalTab').easyResponsiveTabs({
            type: 'vertical', //Types: default, vertical, accordion
            width: 'auto', //auto or any width like 600px
            fit: true, // 100% fit in a container
            closed: 'accordion', // Start closed if in accordion view
            tabidentify: 'hor_1', // The tab groups identifier
            activate: function(event) { // Callback function if tab is switched
                var $tab = $(this);
                var $info = $('#nested-tabInfo2');
                var $name = $('span', $info);
                $name.text($tab.text());
                $info.show();
            }
        });


    // Description More and Less
    $(document).on("click",".custom-more",function(){
          /*const buttonElement = $(this);
          const parentElment = buttonElement.parent(".short-description");
          const nextElement = parentElment.next(".short-description-long-text");
          parentElment.hide();
          nextElement.show();*/
          $(".short-description").hide();
          $(".short-description-long-text").show();
      });
    $(document).on("click",".custom-less",function(){
         /* const buttonElement = $(this);
          const parentElment = buttonElement.parent(".short-description-long-text");
          const prevElement = parentElment.prev(".short-description");
          parentElment.hide();
          prevElement.show();*/
          $(".short-description").show();
          $(".short-description-long-text").hide();
      });
    //  $(document).on("click",".active_ingredient_value .button",function(){
    //   $('#popup1').addClass('active');
    // });

$(document).on("click",".plus-icons",function(){
  var active_date = $(this).closest('.ingredient-list').html();

    $('#popups').addClass('active');
    $('.active-ingredient-tooltipsd').html(active_date);
});
  $(document).on("click",".close",function(){
    $('#popups').removeClass('active');
    $('.active-ingredient-tooltipsd').html('');
});
setInterval(function(){
var numItems = $('.widget-fallback_message').length;
if(numItems == 1){
$('#ppage-shipping-app').hide();
}

var varName = $('.options-selection__select-label').text();
if(varName == 'Variant Size'){
    $('.options-selection__select-label').text('size');
}

  }, 1000);
    });

 setInterval(function () {
   function Ascending_sort(a, b) { 
      return ($(b).text().toUpperCase()) <
      ($(a).text().toUpperCase()) ? 1 : -1;  
    } 

  $(".active-ingredients-Blog ul.blog--inner li").sort(Ascending_sort).appendTo('.active-ingredients-Blog ul.blog--inner'); 
  $(".active-ingredients-Blog .blog-title").text(""); 
},1200);

$(document).ready(function() {
  setInterval(function () {
    $('.variant-selector').change(function() {
      var selectedVariantId = $(this).val();
      var price = $(this).find(':selected').data('price');
      var compare_at_price = $(this).find(':selected').data('compare-price');
      var parentDiv = $(this).closest('.productitem__container');
      if($(".variant-details[data-value='" + selectedVariantId + "']").attr("data-available") === 'true'){
        $(parentDiv).find("button.productitem--action-trigger").addClass("add-to-cart");
        $(parentDiv).find("button.productitem--action-trigger").removeClass("disabled");
        $(parentDiv).find("button.productitem--action-trigger").removeAttr("disabled");
        $(parentDiv).find("button.productitem--action-trigger").attr("data-variant-id", selectedVariantId);
        $(parentDiv).find("button.productitem--action-trigger").text("Add to Cart");
        $(parentDiv).find(".product-stock-level").addClass("product-stock-level--high");
        $(parentDiv).find(".product-stock-level").find(".product-stock-level__badge-text").text("In stock");
        $(parentDiv).find(".productitem--listview-badge").html("");
        $(parentDiv).find(".altr-pro-btns:eq(0)").hide();
      }
      else{
        $(parentDiv).find("button.productitem--action-trigger").removeClass("add-to-cart");
        $(parentDiv).find("button.productitem--action-trigger").addClass("disabled");
        $(parentDiv).find("button.productitem--action-trigger").attr("disabled", "disabled");
        $(parentDiv).find("button.productitem--action-trigger").attr("data-variant-id", selectedVariantId);
        $(parentDiv).find("button.productitem--action-trigger").text("Sold out");
        $(parentDiv).find(".product-stock-level").addClass("product-stock-level--none");
        $(parentDiv).find(".product-stock-level").find(".product-stock-level__badge-text").text("Out of stock");
        $(parentDiv).find(".productitem--listview-badge").html("<span class='productitem__badge productitem__badge--soldout'>Sold out</span>");
        $(parentDiv).find(".altr-pro-btns:eq(0)").show();
      }
      if(compare_at_price != ''){
        $(parentDiv).find(".productitem--listview-badge").html('<span class="productitem__badge productitem__badge--sale" data-badge-sales=""><span data-badge-sales-range="">Sale</span><span data-badge-sales-single="" style="display: none;">Sale</span></span>');
      }
      console.log(compare_at_price);
      $(parentDiv).find(".productitem--actions").find(".price__current").find(".money").attr("data-main-price", price);
      $(parentDiv).find(".price__current").find(".money").text(price);
      $(parentDiv).find(".price__compare-at").find(".money").text(compare_at_price);
      var productLink = $(this).closest('.productitem--info').find('a');
      var originalHref = productLink.attr('href');
      var newHref = originalHref.split('?')[0] + '?variant=' + selectedVariantId;
      productLink.attr('href', newHref);
    });
    },1200); 
  });
  $("body").on("click",".quantity-selector__button", function(){
    var qty = $(this).closest(".quantity-selector__wrapper").find("input[type=number]").val();
    $(".price__current").find("span.money[data-price]").addClass("op-0-3");
    var prodInventory = parseInt($(this).attr("data-inventroy-val"));
    var quantityInput = parseInt($(this).closest(".quantity-selector__wrapper").find("input").val());
    // console.log(prodInventory, quantityInput);
    if(quantityInput > prodInventory) {
      $(this).closest(".quantity-selector__wrapper").find("input").val(prodInventory);
    }
    updatePrice(qty);
  });
  $("body").on("blur",".quantity-selector__input", function(){
    var qty = $(this).val();
    $(".price__current").find("span.money[data-price]").addClass("op-0-3");
    var prodInventory = parseInt($(this).closest(".quantity-selector__wrapper").find(".quantity-selector__button").attr("data-inventroy-val"));
    var quantityInput = parseInt($(this).val());
    // console.log(prodInventory, quantityInput);
    if(quantityInput > prodInventory) {
      $(this).val(prodInventory);
    }
    updatePrice(qty);
  });
  $("body").on("change",".options-selection__input-select", function(){

    var qty = $(this).closest(".product-details[data-product-details]").find(".quantity-selector__wrapper").find("input[type=number]").val();
    $(".price__current").find("span.money[data-price]").addClass("op-0-3");
    var currentVariant = $("option:selected", this);
    var currentVariant = this.value;
    var selectedVariantOption = $('.variant-selection__variants option[data-variant-title="'+currentVariant+'"]');
    var selectedVariantInvtory = $(selectedVariantOption).attr("data-inventroy-val");
    $(this).closest(".product-form__action-wrapper").find(".quantity-selector__button").attr("data-inventroy-val", selectedVariantInvtory);
    var quantityInput = parseInt($(this).closest(".product-form__action-wrapper").find("input[type=number]").val());
    // console.log(prodInventory, quantityInput);
    if(quantityInput > selectedVariantInvtory) {
      $(this).closest(".product-form__action-wrapper").find("input[type=number]").val(selectedVariantInvtory);
    }
    // console.log(currentVariant, selectedVariantInvtory);
    setTimeout(() => {
      updatePrice(qty);
    }, 1500);
  })

  function updatePrice(qty){
    var discountPrice=0, firstDigit=0, secondDigit = 0;
    var productDetailDiv = $(".product-details[data-product-details]").find(".tbl-qb-grid").find("tbody tr");
    if($(".product-details[data-product-details]").find(".tbl-qb-grid").length > 0){
      var productDetailDiv = $(".product-details[data-product-details]").find(".tbl-qb-grid").find("tbody tr");
      $(productDetailDiv).each(function(index){
        var dataQty = $(this).data("qty");
        var secondPoint = $(".product-details[data-product-details]").find(".tbl-qb-grid").find("tbody tr:eq('"+(index + 1)+"')");
        if(secondPoint === 'undefined'){
          secondPoint = parseInt(1000);
        }
        if(dataQty <= qty && qty < secondPoint){
          discountPrice = $(this).attr("data-price");
        }
      });
    }
    else{
      discountPrice = parseFloat($(".price__current").find("span.money[data-price]").eq(0).text().replace('$',''));
    }

    numberWithCommas((discountPrice*1.0000000000000000000001).toFixed(2))
    // $(".price__current").find("span.money[data-price]").text("$"+parseFloat(discountPrice*1.0000000000000000000001).toFixed(2));
    $(".price__current").find("span.money[data-price]").removeClass("op-0-3");
    untiPriceUpdate(discountPrice);
  }
  function numberWithCommas(x) {
    finalNumber =  x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    $(".price__current").find("span.money[data-price]").text("$"+finalNumber);
  }
  $(document).ready(function() {
    setInterval(function() {
      filterCleanup();
    },2000);
  });

  function untiPriceUpdate(productPrice) {
    var unitPrice = productPrice;
    var price = $('.variant-selection__variants option:selected').attr('data-value');
    if(typeof price === 'undefined'){
      price = $('.pro-compare-price').attr('data-unit');
    }
    var total = unitPrice / price;
    $('.unit-original').text(total.toFixed(2));
  }

$("body").on("click", ".check_states_button", function () {
    var count = 0;
    $(".product-actives_cart").find(".no_alter_product").remove();
  $(".alter_product").removeClass("alter_product_show");
    var userState = $(this).closest(".cart-checkout").find(".all_states_select").val();
    var alternate_restrict_check = false;
    var loopsCompleted = 0; // Counter to track loop completion

    if (userState !== '--None--') {
        $(".cartitems--list li").each(function (index) {
            var ristrictStates = $(this).data("item-states");
            if (ristrictStates) {
                if (ristrictStates.includes(userState)) {
                    $(this).find(".restrict_state_error_msg span").text(userState);
                    count++;
                    $(this).addClass("restricted_item");
                    $('html, body').animate({
                        scrollTop: $(this).offset().top - 170
                    }, 200);
                } else {
                    $(this).removeClass("restricted_item");
                }
            }
        });

        loopsCompleted++; // Increment counter when first loop finishes
        checkAndRunStateContactForm(); // Check if both loops are done

        if (count === 0) {
            $(".check_states_button").hide();
            $(".cart-checkout .button-primary[name='checkout']").show();
            var formData = $("#cart-checkout-from").serialize();
            $.ajax({
                url: '/cart',
                type: 'POST',
                data: formData,
                beforeSend: function () {
                    $("#cart-request-form").addClass('sending');
                },
                error: function (t) {
                    console.log(t);
                },
                success: function (response) {
                    console.log('here send');
                }
            });
            setTimeout(function () {
                localStorage.removeItem("stateVal")
                $("body").find(".cart-checkout .button-primary[name='checkout']").click();
            }, 500);
        }
        else {
            $(".product-actives_cart .alter-product").each(function (index) {
                var ristrictState = $(this).data("state");
                if (ristrictState && userState && ristrictState.includes(userState)) {
                    $(this).hide();
                    $(this).addClass('alternate_restrict');
                    $(this).removeClass('not-restrict-state');
                }
            });

            $(".restricted_item .product-actives_cart").each(function (index) {
                var notRestrictState = $(this).find(".not-restrict-state");
                if (notRestrictState.length > 0) {
                    $(notRestrictState).each(function (index) {
                        var isAvailable = $(notRestrictState).eq(index).data("available");
                        if (isAvailable === true || isAvailable === 'true') {
                            $(notRestrictState).eq(index).addClass("alternate_product_available");
                            alternate_restrict_check = true;
                        }
                    });
                }
            });

            loopsCompleted++; // Increment counter when second loop finishes
            checkAndRunStateContactForm(); // Check if both loops are done
        }

        $(".restricted_item .product-actives_cart").each(function (index) {
            if ($(this).find(".alternate_product_available").length === 0) {
                $(this).append("<p class='no_alter_product'>Please allow us to help you find an alternative product. Call us <a href='tel:877-272-0244'>877-272-0244</a> or <a target='_blank' href='/pages/contact'>Request Quote</a></p>")
            } else {
                $(this).find('.alter-product.not-restrict-state.alternate_product_available').first().css('display', 'block');
                $(this).find('.alter-product.not-restrict-state.alternate_product_available').first().addClass("alter_product_show");
            }
        });

    } else {
        $(".state_error_empty").show();
        setTimeout(function () {
            $(".state_error_empty").hide();
        }, 2000)
    }

    // Function to check and run stateContactForm
    function checkAndRunStateContactForm() {
        if (loopsCompleted === 2) {
            setTimeout(function () { 
                stateContactForm(userState); 
            }, 1000); // Small delay to ensure UI updates are applied
        }
    }
});

function stateContactForm(userState){
  $(".cart-item.restricted_item").each(function(index){
    var productName = $(this).data("name");
    var productQuantity = $(this).attr("data-quantity");
    var d = new Date($.now());
    var dateTime = d.getDate()+'-'+(d.getMonth() + 1)+'-'+d.getFullYear()+' '+d.getHours()+':'+d.getMinutes()+':'+d.getSeconds();
    var alterProduct = $(this).find(".alter-product.alter_product_show").attr("data-name");
    $("#cart-request-form").append('<input name="contact[Date Time]" type="text" value="'+dateTime+'">');
    $("#cart-request-form").append('<input name="contact[product '+(index + 1)+']" type="text" value="'+productName+'">');
    $("#cart-request-form").append('<input name="contact[quantity '+(index + 1)+']" type="number" value='+productQuantity+'>');
    $("#cart-request-form").append('<input name="contact[state]" type="text" value='+userState+'>');
    // console.log($(this).find('.alter-product.not-restrict-state.alternate_product_available').first().is(":visible"));
            if ($(this).find('.alter-product.not-restrict-state.alternate_product_available.alter_product_show').length > 0) {
                $("#cart-request-form").append('<input name="contact[Alternate Product '+(index+1)+']" type="text" value="'+alterProduct+'">');
            }

  });
  $("#cart-request-form").submit();
}

$("body").on("click", ".alternate-pd-atc", function(e){
  e.preventDefault();
  var prdId = $(this).data("id");
  var removeId = $(this).closest(".product-actives_cart").closest(".cart-item").data("cartitem-key");
  if($(this).hasClass("prd-property")){
    var dataProperty = $(this).attr("data-product");
    var proData = {id:prdId,quantity:1,properties:{Size:dataProperty}}
  }
  else{
    var proData = {id:prdId,quantity:1}
  }
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      quantity: 0,
      id: removeId
    },
    dataType: 'json',
    success: function(data) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: proData,
        dataType: 'json',
        success: function(data) {
          setTimeout(function() {
            window.location.replace("/cart");
          },2000)
        },
        error: function(xhr, status, error) {
          // Handle errors
          console.error(xhr.responseText);
        }
      });
    },
  });
});

$("body").on("change", ".all_states_select", function(){
  var stateVal = $(this).val();
  $(".state_error").hide();
  $(".check_states_button").removeClass("op-6");
  if(stateVal == 'VT'){
    $(".state_error").show();
    $(".check_states_button").addClass("op-6");
  }
  else{
    $("state_error").show();
    $(".check_states_button").show();
    $(".cart-checkout .button-primary[name='checkout']").hide();
  }
});
$(document).ready(function() {
    $('.type_options').select2({
      placeholder: "All Product Types",
      allowClear: true
    });
    $('.application_options').select2({
      placeholder: "All Product Applications",
      allowClear: true
    });
    $('.manu_options').select2({
      placeholder: "All Manufacturer",
      allowClear: true
    });
    $('.ingre_options').select2({
      placeholder: "All Active Ingredients",
      allowClear: true
    });
    $('.use_options').select2({
      placeholder: "All Areas of use",
      allowClear: true
    });
    $('.target_options').select2({
      placeholder: "All Target Pests",
      allowClear: true
    });
});

$("body").on("click", ".search_filter_button", function(){
  var type_options = $('.type_options').val();
  var application_options = $('.application_options').val();
  var manu_options = $('.manu_options').val();
  var ingre_options = $('.ingre_options').val();
  var use_options = $('.use_options').val();
  var target_options = $('.target_options').val();
  var shop = $(this).data('shop');

  var queryString = "";

  if (type_options) {
    queryString += "filter.p.tag=" + encodeURIComponent(type_options) + "&";
  }
  if (application_options) {
    queryString += "filter.p.tag=" + encodeURIComponent(application_options) + "&";
  }
  if (manu_options) {
    queryString += "filter.p.vendor=" + encodeURIComponent(manu_options) + "&";
  }
  if (ingre_options) {
    queryString += "filter.p.tag=" + encodeURIComponent(ingre_options) + "&";
  }
  if (use_options) {
    queryString += "filter.p.tag=" + encodeURIComponent(use_options) + "&";
  }
  if (target_options) {
    queryString += "filter.p.tag=" + encodeURIComponent(target_options) + "&";
  }

  // Remove the last '&' character
  if (queryString.endsWith("&")) {
    queryString = queryString.slice(0, -1);
  }

  if (queryString) {
    // Perform your AJAX call or any other logic here
    console.log("Query String: " + queryString);
  }
  // console.log(selectedOptions);
  if(type_options || application_options || manu_options || ingre_options || use_options || target_options){
    var url = shop+'/collections/custom-collection?'+queryString;
    // else{
    //   var url = shop+'/collections/custom-collection';
    // }
    $.ajax({
      type: 'GET',
      url: url,
      success: function(data) {
        $('.search_product_list').html('');
        $('.search_product_list').html(data);
      },
      error: function(xhr, status, error) {}
        // Handle errors
    });
  }
});

function filterCleanup(){
  var targetEl = $(".cloud-search-filter[data-filter-name='Application']").find(".cloud-search-filter-value");
  targetEl.each(function(index) {
    $(this).find(".cloud-search-filter-value__name").text($(this).find(".cloud-search-filter-value__name").text().split(":")[1]);
  });

  var targetE2 = $(".cloud-search-filter[data-filter-name='Types']").find(".cloud-search-filter-value");
  targetE2.each(function(index) {
    $(this).find(".cloud-search-filter-value__name").text($(this).find(".cloud-search-filter-value__name").text().split(":")[1]);
  });

  var targetE3 = $(".cloud-search-filter[data-filter-name='Target Pests']").find(".cloud-search-filter-value");
  targetE3.each(function(index) {
    if($(this).attr("data-filter-value").indexOf("_target") >= 0){
      $(this).find(".cloud-search-filter-value__name").text($(this).find(".cloud-search-filter-value__name").text().split("_")[0]);
    }
    else{
      $(this).remove();
    }
  });

  var targetE4 = $(".cloud-search-filter[data-filter-name='Area of use']").find(".cloud-search-filter-value");
  targetE4.each(function(index) {
    if($(this).attr("data-filter-value").indexOf("_areaOfUse") >= 0){
      $(this).find(".cloud-search-filter-value__name").text($(this).find(".cloud-search-filter-value__name").text().split("_")[0]);
    }
    else{
      $(this).remove();
    }
  });

  var targetE5 = $(".cloud-search-filter[data-filter-name='Active ingredient']").find(".cloud-search-filter-value");
  targetE5.each(function(index) {
    $(this).find(".cloud-search-filter-value__name").text($(this).find(".cloud-search-filter-value__name").text().split("_")[0]);
  });
}

// $("body").on("click", "div[data-filter-name='Target Pests'] .cloud-search-filter__name", function(){
//   var targetE3 = $(this).closest(".cloud-search-filter").find(".cloud-search-filter-value");
//   targetE4.each(function(index) {
//     if($(this).attr("data-filter-value").indexOf("_target") >= 0){
//       $(this).find(".cloud-search-filter-value__name").text($(this).find(".cloud-search-filter-value__name").text().split("_")[0]);
//     }
//     else{
//       $(this).remove();
//     }
//   });
// });

// $("body").on("click", "div[data-filter-name='Active ingredient'] .cloud-search-filter__name", function(){
//   var target = $(this).closest(".cloud-search-filter").find(".cloud-search-filter-value");
//   target.each(function(index) {
//     $(this).find(".cloud-search-filter-value__name").text($(this).find(".cloud-search-filter-value__name").text().split("_")[0]);
//   });
// });

// $("body").on("click", "div[data-filter-name='Area of use'] .cloud-search-filter__name", function(){
//   var targetE4 = $(this).closest(".cloud-search-filter").find(".cloud-search-filter-value");
//   targetE4.each(function(index) {
//     if($(this).attr("data-filter-value").indexOf("_areaOfUse") >= 0){
//       $(this).find(".cloud-search-filter-value__name").text($(this).find(".cloud-search-filter-value__name").text().split("_")[0]);
//     }
//     else{
//       $(this).remove();
//     }
//   });
// });

$('body').on('submit', "#cart-request-form", function(e) {
    e.preventDefault();  // Prevent normal form submission
    var formData = $("#cart-request-form").serialize();
    
    // Make sure the honeypot field is empty
    if (!$('#cart-request-form').find('input[name="contact[Date Time]"]').val()) {
      alert("Bot detected!");
      return;
    }
    
    $.ajax({
      url: '/contact',
      type: 'POST',
      data: formData,
      beforeSend: function() {
        $("#cart-request-form").addClass('sending');
      },
      error: function(t) {
          console.log(t);
      },
      success: function(response) {
        console.log('here send');
      }
    });
  });
$("body").on("click", ".site-header-search-mobile", function(){
  $(".live-search").slideToggle();
  $(".small-promo").toggleClass('small-promo-show');
});